export default {
  0: 'NONE',
  1: 'PROPAGATION',
  2: 'VEGETATIVE',
  3: 'FLOWERING',
  4: 'DRYING',
  5: 'MOTHER',
  6: 'IRRIGATION',
  7: 'CLIMATE',
}
